import {
  SpaceProps as MantineSpaceProps,
  Space as MantineSpace,
} from '@mantine/core';

export type SpaceProps = MantineSpaceProps;

export const Space = MantineSpace;

Space.displayName = 'Space';
